import {jsx as _jsx} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import { usePreloadedQuery} from 'react-relay'

import InvitationLinkDialog from './InvitationLinkDialog'
import TeamInvitationMeetingAbstract from './TeamInvitationMeetingAbstract'





const query = graphql`
  query InvitationLinkQuery($token: ID!) {
    massInvitation(token: $token) {
      ...InvitationLinkDialog_massInvitation
    }
  }
`

function InvitationLink(props) {
  const {queryRef} = props
  const data = usePreloadedQuery(query, queryRef)
  const {massInvitation} = data
  // the meeting background is prettier than the plain one, so let's always use it
  return (
    _jsx(TeamInvitationMeetingAbstract, { children: 
      _jsx(InvitationLinkDialog, { massInvitation: massInvitation,} )
    })
  )
}

export default InvitationLink
